import { Controller, Shark } from "shark-mvc";
import moment from "moment";
import User from "../models/User";
import soundManager from "./soundManager";

class NotificationManager extends Controller {
	constructor () {
		super("notificationManager");
	}

	appInit () {
		notificationManager.populateVoiceList();
		speechSynthesis.onvoiceschanged = notificationManager.populateVoiceList;
	}

	isWorkHours (endOffsetSeconds = 0) {
		const { currUser } = Shark.get();
		const currTime = moment().add(endOffsetSeconds, "s").format("HH:mm");
		const workingHours = currUser.preferences.workingHours;
	
		for (let i = 0; i < workingHours.length; i++) {
			const currWorkingHour = workingHours[i];
	
			if (currWorkingHour.start < currTime && currWorkingHour.end > currTime) {
				return true;
			}
		}
		
		return false;
	}

	notifyShouldBeWorking () {
		return; 
		
		const { currUser } = Shark.get();

		switch (currUser.preferences.notifications.type) {
			case User.NOTIFICATION_TYPE_BEEP:
				soundManager.beep(500, 400, currUser.preferences.notifications.volume);
				break;
			case User.NOTIFICATION_TYPE_SOUND:
				break;
			case User.NOTIFICATION_TYPE_VOICE:
				notificationManager.speak("Dovresti stare lavorando...");
				break;
		}
	}

	populateVoiceList () {
		const synth = speechSynthesis;
		const voices = synth.getVoices();
		// console.log({voices});

		Shark.set({
			availableVoices: voices,
		});
		notificationManager.setActiveVoice();
	}

	setActiveVoice (speakTest = false) {
		const { availableVoices, currUser } = Shark.get();

		if (availableVoices.length > 0 && currUser) {
			let preferredVoice;
			
			if (currUser && currUser.preferences?.notifications?.voice) {
				preferredVoice = availableVoices.find(item => item.voiceURI === currUser.preferences.notifications.voice);
			}
			
			if (!preferredVoice) {
				preferredVoice = availableVoices[0];
			}

			notificationManager.set("activeVoice", preferredVoice);
			// console.log("Imposto la voce a:", currUser?.preferences?.notifications?.voice, preferredVoice);

			if (speakTest) {
				notificationManager.speak("Dovresti stare lavorando...");
			}
		}
	}

	speak (message) {
		var utterThis = new SpeechSynthesisUtterance(message);
	
		utterThis.voice = this.get("activeVoice");
		utterThis.pitch = 1.2;
		utterThis.rate = 1.2;
		const speakResult = speechSynthesis.speak(utterThis);
		// console.log({speakResult});
		// var context = new AudioContext();
	
		// var osc = context.createOscillator();
		// osc.frequency.value = 1440;
		// osc.connect(context.destination);
		// osc.start(0);
	
		// setTimeout(() => {
		// 	osc.stop();
		// }, 300);
	}

	startShouldBeWorkingNotifications () {
		if (this.$store.notificationTimerId == null) {
			const { currUser } = Shark.get();
			
			// Since next notification shouldn't be triggered after working time ends, we check if will still be working time after "frequency" minutes from now.
			if (currUser.preferences.notifications.type !== "none" && notificationManager.todayIsWorkDay() && this.isWorkHours(currUser.preferences.notifications.frequency * 60)) {
				const notificationTimerId = setTimeout(() => {
					this.notifyShouldBeWorking();
					this.startShouldBeWorkingNotifications();
				}, currUser.preferences.notifications.frequency * 60000);
				
				this.set("notificationTimerId", notificationTimerId);
			}
		}
	}

	stopNotWorkingTimeNotifications () {
		clearTimeout(this.$store.notificationTimerId);
		this.$store.notificationTimerId = null;
	}

	todayIsWorkDay () {
		const currUser = Shark.get("currUser");
		const todayInTheWeek = new Date().getDay();
	
		switch (todayInTheWeek) {
			case 0:
				return currUser.preferences.workDays.sunday;
			case 1:
				return currUser.preferences.workDays.monday;
			case 2:
				return currUser.preferences.workDays.tuesday;
			case 3:
				return currUser.preferences.workDays.wednesday;
			case 4:
				return currUser.preferences.workDays.thursday;
			case 5:
				return currUser.preferences.workDays.friday;
			case 6:
				return currUser.preferences.workDays.saturday;
		}
	}
}

const notificationManager = new NotificationManager();

Shark.registerController(notificationManager);

export default notificationManager;